import styled from 'styled-components'
import { desktopVw } from '../../styles/utils'

const FormHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    text-transform: uppercase;
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 60px;
    letter-spacing: 1px;
    font-family: ${props => props.theme.fonts.grosa};
    font-weight: 500;

    i {
      font-family: ${props => props.theme.fonts.secondary};
      font-size: 45px;
      line-height: 40px;
      font-style: normal;
    }
  }

  h3 {
    font-size: 14px;
    letter-spacing: 2px;
    font-weight: 500;
    font-family: ${props => props.theme.fonts.grosa};
  }

  p {
    margin-bottom: 18px;
    line-height: 17px;
    font-size: 11px;
    font-family: ${props => props.theme.fonts.grosa};
  }

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    align-items: flex-start !important;

    h1 {
      font-size: ${desktopVw(24)};
      line-height: ${desktopVw(30)};
      margin-bottom: ${desktopVw(60)};
      margin-top: ${desktopVw(55)};

      i {
        font-size: ${desktopVw(45)};
        line-height: ${desktopVw(40)};
      }
    }

    h3 {
      font-size: ${desktopVw(16)};
    }

    p {
      margin-bottom: ${desktopVw(18)};
      line-height: ${desktopVw(17)};
      font-size: ${desktopVw(11)};
    }
  }
`

export default FormHeader
